import useState from 'react';

export default function SecondaryInventoryRow({
    secondaryInventoryData,
    updateSelectedInventory,
    setData,
    selectedInventory,
    brokerMarkup,
    setCommentData,
}) {
    const [showPopup, setShowPopup] = useState(false);
    const defaultPopupPosition = { left: '0px', top: '0px' };
    const [popupPositionStyle, setPopupPositionStyle] = useState(defaultPopupPosition);

    const updateInventoryPrice = (input, brokerPrice = false) => {
        setData((prevData) => {
            const updatedSecondaryInventory = prevData?.secondaryInventory?.map((data) => {
                if (data.name === secondaryInventoryData?.name) {
                    return {
                        ...data,
                        price: brokerPrice ? secondaryInventoryData?.price : input,
                        brokerPrice: brokerPrice ? input : secondaryInventoryData?.brokerPrice,
                    };
                }
                return data;
            });
            return {
                ...prevData,
                secondaryInventory: updatedSecondaryInventory,
            };
        });

        // Remove empty price selections
        if ((selectedInventory?.some((inv) => inv === secondaryInventoryData.name) && input === 0) || input === '') {
            updateSelectedInventory(
                { target: { checked: false } },
                secondaryInventoryData.name,
                secondaryInventoryData.quantity
            );
        }
    };

    const updateInventoryLeadTime = (input) => {
        setData((prevData) => {
            const updatedSecondaryInventory = prevData?.secondaryInventory?.map((data) => {
                if (data.name === secondaryInventoryData?.name) {
                    return {
                        ...data,
                        leadTime: input,
                    };
                }
                return data;
            });
            return {
                ...prevData,
                secondaryInventory: updatedSecondaryInventory,
            };
        });
    };

    return (
        <tr className='text-center border-b last:border-none'>
            <td className='px-4 py-3'>{secondaryInventoryData.name}</td>
            <td>{secondaryInventoryData.condition}</td>
            <td className='w-[135px]'></td>
            <td>{secondaryInventoryData.trace}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
                {showPopup && secondaryInventoryData.comments && secondaryInventoryData.comments !== '' ? (
                    <article className='flex absolute z-50 w-[300px]' style={popupPositionStyle}>
                        <div className='min-w-[140px] bg-gray-800 text-white rounded-md px-2 py-1 whitespace-pre-wrap break-words'>
                            {secondaryInventoryData.comments}
                        </div>
                    </article>
                ) : null}
                <textarea
                    className='max-w-[110px] px-1 py-2 border rounded-md resize-none'
                    type='text'
                    value={secondaryInventoryData.comments}
                    id={secondaryInventoryData?.inventoryId}
                    onMouseOver={() => {
                        const rect = document.getElementById(secondaryInventoryData?.inventoryId).getBoundingClientRect();
                        const x = rect.left + window.scrollX - rect.width / 2;
                        const y = rect.bottom + window.scrollY + 4;

                        setPopupPositionStyle({ left: x, top: y });
                        setShowPopup(true);
                    }}
                    onMouseLeave={() => {
                        setShowPopup(false);
                    }}
                    onDoubleClick={() =>
                        setCommentData({
                            quoteLineId: secondaryInventoryData?.inventoryId,
                            comments: secondaryInventoryData?.comments,
                            open: true,
                            readonly: true,
                        })
                    }
                    rows={1}
                />
            </td>
            <td>{secondaryInventoryData.customer}</td>
            <td>{secondaryInventoryData.costToPurchase}</td>
            <td>
                <input
                    className='h-fit py-1 w-[50px] rounded-md border px-1'
                    type='number'
                    defaultValue={0}
                    onChange={(e) => updateInventoryLeadTime(e.target.value)}
                />
            </td>
            <td className='w-[120px]'>
                <input
                    className='h-fit py-1 w-[110px]'
                    type='text'
                    defaultValue={secondaryInventoryData.price}
                    onChange={(e) => updateInventoryPrice(e.target.value)}
                />
            </td>
            {/* <td className='h-fit py-1 w-[110px] rounded-md px-1'>
                {!brokerMarkup
                    ? parseFloat(secondaryInventoryData.price)
                    : parseFloat(secondaryInventoryData.price) +
                      parseFloat(secondaryInventoryData.price) * (brokerMarkup / 100)}
            </td> */}
            <td className='w-[102px]'>{secondaryInventoryData.quantity}</td>
            <td className='w-[80px]'></td>
            <td className='w-[93px]'>
                <input
                    className='w-8 scale-150'
                    type='checkbox'
                    onChange={(e) =>
                        updateSelectedInventory(e, secondaryInventoryData.name, secondaryInventoryData.quantity)
                    }
                />
            </td>
        </tr>
    );
}
